import { NoticeConstructionUpdate } from "./noticeconstructionupdate";
import { UnreadMessage } from "./unread-message";

export class Notice {
  public noticeId: number;
  public noticeTypeId: number;
  public noticeType?: string; 
  public audianceTypeId: number;
  public audianceGuid: string;
  public startDate: string; 
  public endDate: string;
  public isActive: boolean;
  public createdUtcDate: string;
  public createdBy: string;
  public lastModifiedUtcDate: string;
  public lastModifiedBy: string;
  public constructionUpdate?: NoticeConstructionUpdate;
  public unreadMessage?: UnreadMessage;
}
